
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetojaipurcabs() {



    const cardData =
    {
        keyword: 'Pune to Jaipur Cabs ',
        heading: 'Platinum24 Cabs: Pune to Jaipur Cabs',
        headingDescription: ' Platinum24 Cabs offers reliable Pune to Jaipur cab services for families, pilgrims, tourists, and corporate travelers. Whether you’re heading to the Pink City for a heritage tour of Amer Fort and Hawa Mahal, attending a business event, or planning a family getaway, our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a smooth and comfortable ride. With experienced chauffeurs, punctual pickups, and fully transparent pricing, we make your long-distance journey stress-free. From one-way drops to customized return trips, Platinum24 Cabs guarantees a safe, pleasant, and memorable Pune to Jaipur travel experience.',

        top: 'Top Places to Visit in Jaipur with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Amber Fort",
    "description": "Amber Fort, located on a hilltop 11 km from Jaipur, is a grand Rajput fortress built in the 16th century. Its blend of red sandstone and marble architecture impresses visitors. Sheesh Mahal (Mirror Palace) and Diwan-i-Khas showcase royal artistry. Elephant and jeep rides take tourists up the fort. Light-and-sound shows narrate its glorious history at night. Amber Fort is Jaipur’s iconic royal monument."
  },
  {
    "title": "Hawa Mahal",
    "description": "Hawa Mahal, or the Palace of Winds, is Jaipur’s most photographed landmark. Built in 1799, it has 953 intricately carved jharokhas (windows). It allowed royal women to observe street life without being seen. The honeycomb design and pink sandstone façade glow beautifully in sunlight. Visitors also explore small museums inside. Hawa Mahal is Jaipur’s architectural pride."
  },
  {
    "title": "City Palace",
    "description": "City Palace, located in the heart of Jaipur, was the royal residence of the Maharajas. Built in a blend of Rajput, Mughal, and European styles, it features grand courtyards and museums. The palace houses Chandra Mahal and Mubarak Mahal, filled with artifacts, textiles, and royal arms. Visitors admire its Peacock Gate and Diwan-i-Aam. It still houses the Jaipur royal family. City Palace is Jaipur’s living royal heritage."
  },
  {
    "title": "Jantar Mantar",
    "description": "Jantar Mantar, a UNESCO World Heritage Site, is an astronomical observatory built by Maharaja Jai Singh II. It houses the world’s largest stone sundial. The site has 19 instruments used to measure time, track stars, and predict eclipses. It reflects India’s scientific and architectural excellence. Tourists and researchers find it fascinating. Jantar Mantar is Jaipur’s unique heritage of science."
  },
  {
    "title": "Nahargarh Fort",
    "description": "Nahargarh Fort, perched on the Aravalli hills, offers panoramic views of Jaipur city. Built in 1734, it served as a retreat palace for the royals. The palace complex has ornate interiors and step wells. It is especially popular for sunset views and evening outings. Cafes and cultural programs add modern charm. Nahargarh Fort is Jaipur’s scenic watchtower of history."
  },
  {
    "title": "Jaigarh Fort",
    "description": "Jaigarh Fort, built in 1726, is famous for housing the world’s largest cannon on wheels, Jaivana. The fort overlooks Amber Fort and served as a defense stronghold. It has grand gateways, watchtowers, and underground passages. Visitors explore its museums and royal armory. The fort offers majestic views of hills and palaces. Jaigarh is Jaipur’s fortress of strength and pride."
  },
  {
    "title": "Albert Hall Museum",
    "description": "Albert Hall Museum, built in 1887, is Rajasthan’s oldest museum located in Ram Niwas Garden. Its Indo-Saracenic architecture is stunning, especially when illuminated at night. The museum houses rare artifacts, paintings, coins, and an Egyptian mummy. Tourists enjoy exploring its cultural and historic exhibits. The surrounding gardens are perfect for walks. Albert Hall is Jaipur’s cultural knowledge hub."
  },
  {
    "title": "Jal Mahal",
    "description": "Jal Mahal, or the Water Palace, is a beautiful architectural wonder located in Man Sagar Lake. Built in Rajput style, most of the palace remains submerged, with only its top floor visible. The reflection in the water creates a magical sight. Evening views are particularly enchanting. Though entry inside is restricted, tourists admire it from the banks and boats. Jal Mahal is Jaipur’s romantic lakeside gem."
  },
  {
    "title": "Birla Mandir",
    "description": "Birla Mandir, also known as Laxmi Narayan Temple, is a modern white marble temple in Jaipur. Built by the Birla family, it is dedicated to Lord Vishnu and Goddess Laxmi. The temple’s stained glass windows depict mythological stories. Its serene ambiance attracts devotees and tourists alike. At night, the illuminated temple looks divine. Birla Mandir is Jaipur’s spiritual and architectural jewel."
  },
  {
    "title": "Johari Bazaar",
    "description": "Johari Bazaar is Jaipur’s most famous shopping street, known for traditional jewelry, textiles, and handicrafts. Shoppers buy gemstones, meenakari jewelry, lehengas, and bandhani fabrics. The market’s pink-colored shops reflect the city’s heritage. Street food like kachoris and lassi add flavor to the experience. It is always buzzing with locals and tourists. Johari Bazaar is Jaipur’s vibrant cultural marketplace."
  }
],


      "services": [
    {
      "name": "Pune to Jaipur Cab",
      "description": "Travel comfortably with our Pune to Jaipur Cab service, offering a seamless and reliable ride across states. Whether you're planning a business trip or a leisure getaway, our fleet of clean, well-maintained vehicles and professional drivers ensures a smooth journey every time."
    },
    {
      "name": "Book Pune to Jaipur Cab Online",
      "description": "Booking your cab from Pune to Jaipur has never been easier. Use our intuitive online platform to select your vehicle, schedule your ride, and confirm your booking in minutes. Enjoy instant confirmations, secure payment options, and real-time updates for a hassle-free experience."
    },
    {
      "name": "Pune to Jaipur Taxi Service",
      "description": "Our Pune to Jaipur Taxi Service is designed for travelers seeking reliable and timely intercity transportation. With courteous drivers, well-equipped vehicles, and 24/7 customer support, we ensure you reach your destination safely and comfortably, no matter the time or occasion."
    },
    {
      "name": "Pune to Jaipur Car Rental",
      "description": "Choose our Pune to Jaipur Car Rental service for flexible travel options, including both self-drive and chauffeur-driven rentals. With a variety of car types and rental durations available, we cater to solo travelers, families, and corporate clients seeking convenience and control over their travel."
    },
    {
      "name": "Affordable Cabs Pune to Jaipur",
      "description": "Save more on long-distance travel with our Affordable Cabs from Pune to Jaipur. Designed to offer comfort at budget-friendly rates, our service is perfect for students, families, and frequent travelers looking to optimize cost without compromising on safety or quality."
    },
    {
      "name": "Pune to Jaipur Cab Booking Service",
      "description": "Use our Pune to Jaipur Cab Booking Service to reserve your ride quickly and easily. With transparent pricing, various vehicle options, and instant confirmations, we simplify your travel planning and ensure a smooth, worry-free booking process."
    },
    {
      "name": "Pune to Jaipur Outstation Taxi",
      "description": "Our Pune to Jaipur Outstation Taxi service is ideal for intercity travel, offering comfortable long-distance transportation with trained drivers and clean, spacious vehicles. Enjoy flexible pickup times, GPS navigation, and reliable service tailored for your travel needs."
    },
    {
      "name": "Pune to Jaipur Taxi Fare",
      "description": "Get complete clarity on Pune to Jaipur Taxi Fare with our upfront pricing model. Our fare estimates include all essential charges with no hidden fees, allowing you to plan your budget confidently before you start your journey."
    },
    {
      "name": "Pune to Jaipur Cab Charges",
      "description": "We offer transparent and competitive Pune to Jaipur Cab Charges, with detailed pricing breakdowns available at the time of booking. Our fixed and fair rates ensure you receive value for money, regardless of travel distance or duration."
    },
    {
      "name": "One Way Cab Pune to Jaipur",
      "description": "Opt for our One Way Cab from Pune to Jaipur and pay only for what you need. Ideal for single-leg journeys, this cost-effective service is perfect for business trips, relocations, or one-time travel plans with no return ride required."
    },
    {
      "name": "Jaipur to Pune Taxi Booking",
      "description": "Need a return trip? Our Jaipur to Pune Taxi Booking service ensures timely and safe travel back to your starting point. With round-the-clock support and experienced drivers, we make your return journey just as smooth as your departure."
    },
    {
      "name": "Pune to Jaipur Road Trip Cab",
      "description": "Turn your journey into an adventure with our Pune to Jaipur Road Trip Cab service. Enjoy scenic routes, flexible stops, and a relaxed travel experience in comfortable vehicles. Perfect for those who love the road as much as the destination."
    },
    {
      "name": "Pune to Jaipur Sedan and SUV Taxi",
      "description": "Choose from our range of Sedan and SUV taxis for your Pune to Jaipur journey. Whether you need the elegance of a sedan or the space of an SUV, we provide well-maintained vehicles suited to your preferences and group size."
    },
    {
      "name": "Luxury Cab from Pune to Jaipur",
      "description": "Upgrade your travel experience with our Luxury Cab from Pune to Jaipur. Featuring premium cars, professional chauffeurs, and top-notch amenities, this service is tailored for travelers who seek elegance, comfort, and exceptional service during long journeys."
    }
  ],
  "tableData": [
    ["Pune to Jaipur Cab", "Book Pune to Jaipur Cab Online"],
    ["Pune to Jaipur Taxi Service", "Pune to Jaipur Car Rental"],
    ["Affordable Cabs Pune to Jaipur", "Pune to Jaipur Cab Booking Service"],
    ["Pune to Jaipur Outstation Taxi", "Pune to Jaipur Taxi Fare"],
    ["Pune to Jaipur Cab Charges", "One Way Cab Pune to Jaipur"],
    ["Jaipur to Pune Taxi Booking", "Pune to Jaipur Road Trip Cab"],
    ["Pune to Jaipur Sedan and SUV Taxi", "Luxury Cab from Pune to Jaipur"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Trusted Pune to Jaipur Cab Service",
    "WhyChoosedescription": "Platinum24 Cabs provides safe and reliable cab services for your Pune to Jaipur journey, ensuring a comfortable travel experience."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles for Long-Distance Travel",
    "WhyChoosedescription": "Choose from sedans, SUVs, and tempo travellers suited for your group size and travel preferences between Pune and Jaipur."
  },
  {
    "WhyChooseheading": "Clean and Sanitized Vehicles for Passenger Safety",
    "WhyChoosedescription": "All our cabs are regularly cleaned and sanitized to offer a safe and hygienic ride on the Pune to Jaipur route."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Pune-Jaipur Routes",
    "WhyChoosedescription": "Our skilled drivers know the best routes between Pune and Jaipur to ensure timely and smooth travel."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "Enjoy clear fare structures that include all charges like tolls, fuel, and driver allowances for Pune to Jaipur trips."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Hassle-Free Booking",
    "WhyChoosedescription": "Our customer care team is available around the clock to assist with your Pune to Jaipur cab bookings."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages for One-Way or Round Trips",
    "WhyChoosedescription": "Choose from hourly, daily, or long-term rental plans tailored for Pune to Jaipur travel."
  },
  {
    "WhyChooseheading": "Easy Online Booking with Instant Confirmation",
    "WhyChoosedescription": "Book your Pune to Jaipur cab quickly through our website or app with immediate confirmation."
  }
]

















    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs offer Pune to Jaipur cab services?',
        answer: 'Yes, Platinum24 Cabs offers reliable long-distance cab services from Pune to Jaipur with well-maintained vehicles and professional drivers.',
    },
    {
        question: 'How can I book a cab from Pune to Jaipur with Platinum24 Cabs?',
        answer: 'You can book easily via our website, mobile app, or by contacting our 24x7 customer support team.',
    },
    {
        question: 'What types of cabs are available for Pune to Jaipur travel?',
        answer: 'We provide a range of vehicles including hatchbacks, sedans, SUVs, and luxury cars depending on your travel needs and comfort.',
    },
    {
        question: 'Is one-way cab booking available from Pune to Jaipur?',
        answer: 'Yes, we offer both one-way and round-trip options for Pune to Jaipur cab bookings.',
    },
    {
        question: 'Are the drivers experienced for Pune to Jaipur long-distance trips?',
        answer: 'Absolutely, our drivers are experienced, licensed, and well-versed with the Pune to Jaipur route.',
    },
    {
        question: 'Can I customize my pickup and drop-off locations in Pune and Jaipur?',
        answer: 'Yes, you can choose your specific pickup and drop-off points for convenience.',
    },
    {
        question: 'What safety and hygiene protocols are followed for Pune to Jaipur cabs?',
        answer: 'All vehicles are sanitized regularly, and our drivers follow strict safety and hygiene standards.',
    },
    {
        question: 'Is Pune to Jaipur cab service available 24x7?',
        answer: 'Yes, Platinum24 Cabs operates 24x7 to accommodate your travel schedule from Pune to Jaipur.',
    },
    {
        question: 'What are the payment options for Pune to Jaipur cab bookings?',
        answer: 'We accept payments through cash, UPI, digital wallets, and all major credit/debit cards.',
    },
    {
        question: 'Are there any customizable packages for Pune to Jaipur cab service?',
        answer: 'Yes, we offer flexible and customizable packages tailored to your travel needs and budget.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Ankit Sharma',
        feedback: 'Had a smooth journey from Pune to Jaipur with Platinum24 Cabs. Clean car, polite driver, and great service!',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Kavita Joshi',
        feedback: 'Professional and punctual. Platinum24 Cabs is my go-to for intercity travel. Highly recommended for Pune to Jaipur trips.',
        rating: 5,
    },
];






































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];









const puneToJaipurCabSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Jaipur Cab Service",
  "image": "https://www.platinum24cab.com/assets/images/pune-to-jaipur-cab.jpg",
  "description": "Book Pune to Jaipur cab service with Platinum24 Cabs. Choose from affordable sedans, SUVs, and luxury cabs for one-way and round trips. Reliable and comfortable taxi options available 24/7.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "32150",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/pune-to-jaipur-cab-service"
  }
};



    return (
        <div>

<Helmet>
  <title>Pune to Jaipur Cab Service | Affordable & Luxury Taxi | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Book Pune to Jaipur cab service with Platinum24 Cabs. Choose from affordable sedans, SUVs, and luxury cabs for one-way and round trips. Reliable and comfortable taxi options available 24/7."
  />
  <meta
    name="keywords"
    content="Pune to Jaipur Cab, Book Pune to Jaipur Cab Online, Pune to Jaipur Taxi Service, Pune to Jaipur Car Rental, Affordable Cabs Pune to Jaipur, Pune to Jaipur Cab Booking Service, Pune to Jaipur Outstation Taxi, Pune to Jaipur Taxi Fare, Pune to Jaipur Cab Charges, One Way Cab Pune to Jaipur, Jaipur to Pune Taxi Booking, Pune to Jaipur Road Trip Cab, Pune to Jaipur Sedan and SUV Taxi, Luxury Cab from Pune to Jaipur"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToJaipurCabSchema)}
  </script>
</Helmet>




            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/98.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetojaipurcabs;